<template>
  <div>
    <h1>Formulário x Mobilidade</h1> <br>
    <form @submit.prevent="filtrarMobilidadesPorFormularios()">
      <b-row>
        <div class="col-sm-3">
          <SGPFormAutocompleteComponent name="ctrl_formulario_id" v-model="filtro.ctrl_formulario_id"
            :listaDeOptions="listaDeFormularios" :optionLabel="'titulo'" :optionValue="'id'"
            :placeholder="loadingFormularios ? 'Carregando filtro Formulários...' : 'Formulário'"
            :somenteLeitura="loadingFormularios" :limpavel="true" v-validate="'required'"
            :error="validationErrors.first('ctrl_formulario_id')" data-vv-as="Formulário" />
        </div>

        <div class="col-sm-2 container-botoes">
          <SGPFormBotaoComponent type="submit">
            Filtrar
          </SGPFormBotaoComponent>
        </div>
      </b-row>
    </form>

    <SGPTabelaComponent v-if="listaDeMobilidadesFormulario.length" :colunas="colunas" :dados="listagem"
      :usuarioPodeExcluir="false" :usuarioPodeEditar="false" :somenteLeitura="true"></SGPTabelaComponent>
    <SGPAlertaComponent v-else class="mt-3" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: "FormularioMobilidadePage",

  data() {
    return {
      filtro: {
        ctrl_formulario_id: '',
      }
    }
  },

  created() {
    this.listarFormularios();
  },

  computed: {
    ...mapGetters('ctrlTarefasMobilidades', ['listaDeMobilidadesFormulario', 'loadingTarefasMobilidades']),
    ...mapGetters('formularios', ['listaDeFormularios', 'loadingFormularios']),

    listagem() {
      return this.listaDeMobilidadesFormulario
        .map(item => {
          return item;
        });
    },

    colunas() {
      return [
        {
          key: 'ctrl_tarefas.map',
          label: 'MAP',
          sortable: false
        },
        {
          key: 'ctrl_tarefa_origem.tarefa',
          label: 'Tarefa Origem',
          sortable: false
        },
        {
          key: 'ctrl_tipo_tarefa.tipo',
          label: 'Tipo Tarefa Origem',
          sortable: false
        },
        {
          key: 'ctrl_conclusao.conclusao',
          label: 'Tipo Conclusão',
          sortable: false
        },
        {
          key: 'ctrl_tarefa_destino.tarefa',
          label: 'Tarefa Destino',
          sortable: false
        },
      ]
    }
  },
  methods: {
    ...mapActions('ctrlTarefasMobilidades', [
      'recuperarMobilidadePorFormulario'
    ]),

    ...mapActions('formularios', ['listarFormularios']),

    filtrarMobilidadesPorFormularios() {
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          this.recuperarMobilidadePorFormulario(this.filtro);
        }
      });
    }
  }
};

</script>